import axios from 'axios';
import useCurrentUser from '../hooks/useCurrentUser';
import { API_HOST } from '../constants/constants';
export const updateCampaign = async (campaignId, details) => {
  const apiURL = API_HOST + '/campaigns/' + campaignId;
  const { token, userID } = useCurrentUser();
  
  try {
    const { data } = await axios.patch(apiURL,{
      campaign:{
        ...details
      }
    },{
      headers: {
      'Content-Type': 'application/json',
        'Authorization': 'Bearer '+token,
        'x-sb-user-id': userID
    }
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};
